// Icon registry: the product icon set (assets/icons, delivered with the
// design) plus the design file's inline feather-style glyphs. All icons are
// 24×24 stroke/currentColor React components — no runtime asset fetches,
// no dangerouslySetInnerHTML (SPEC §9.2).

import type { SVGProps } from 'react';

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

function Svg({ size = 18, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    />
  );
}

export function IconBlur(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M2 19.7798C2 21.0098 2.99 21.9998 4.22 21.9998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 16.4399V13.1099" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.22 7.56006C2.99 7.56006 2 8.55006 2 9.78006" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.2197 21.9998C15.4497 21.9998 16.4397 21.0098 16.4397 19.7798" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.8896 22H7.55957" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.55957 14.2202C7.55957 15.4502 8.54957 16.4402 9.77957 16.4402" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.55957 4.22C7.55957 2.99 8.54957 2 9.77957 2H19.7796C21.0096 2 21.9996 2.99 21.9996 4.22V14.22C21.9996 15.45 21.0096 16.44 19.7796 16.44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.4404 16.4399H13.1104" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.55957 10.9902V7.66016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconCamera(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12.53 20.4201H6.21C3.05 20.4201 2 18.3201 2 16.2101V7.79008C2 4.63008 3.05 3.58008 6.21 3.58008H12.53C15.69 3.58008 16.74 4.63008 16.74 7.79008V16.2101C16.74 19.3701 15.68 20.4201 12.53 20.4201Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.52 17.1001L16.74 15.1501V8.84013L19.52 6.89013C20.88 5.94013 22 6.52013 22 8.19013V15.8101C22 17.4801 20.88 18.0601 19.52 17.1001Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.5 11C12.3284 11 13 10.3284 13 9.5C13 8.67157 12.3284 8 11.5 8C10.6716 8 10 8.67157 10 9.5C10 10.3284 10.6716 11 11.5 11Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconChat(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 9.5H17" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 14.5H14" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconDevices(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M18.3898 2.2002H12.1998C10.2061 2.2002 8.58984 3.81645 8.58984 5.8102C8.58984 7.80394 10.2061 9.4202 12.1998 9.4202H18.3898C20.3836 9.4202 21.9998 7.80394 21.9998 5.8102C21.9998 3.81645 20.3836 2.2002 18.3898 2.2002Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.5 12.5205V16.9305" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.97021 16.9305V6.80051C2.97021 5.40051 4.28021 4.27051 5.89021 4.27051" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.97 16.9302H6.47C6.73 16.9302 6.98 17.0402 7.16 17.2102L8.53 18.5802C8.72 18.7702 8.96 18.8602 9.22 18.8602H14.06C14.43 18.8602 14.77 18.6602 14.93 18.3202L15.37 17.4502C15.54 17.1202 15.88 16.9102 16.24 16.9102H20.51C21.05 16.9102 21.48 17.3502 21.48 17.8802V18.8502C21.48 20.4702 20.17 21.7702 18.56 21.7702H4.92C3.3 21.7702 2 20.4602 2 18.8502V17.8802C2 17.3402 2.44 16.9102 2.97 16.9102V16.9302Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconFiles(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 7.75V14.5C18 13.4 17.1 12.5 16 12.5H8C6.9 12.5 6 13.4 6 14.5V7.75C6 6.65 6.9 5.75 8 5.75H16C17.1 5.75 18 6.65 18 7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19 15.75H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 15.75H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 14V11C18 9.9 17.1 9 16 9H8C6.9 9 6 9.9 6 11V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 14.5V15.75H14.5C14.5 17.13 13.38 18.25 12 18.25C10.62 18.25 9.5 17.13 9.5 15.75H6V14.5C6 13.4 6.9 12.5 8 12.5H16C17.1 12.5 18 13.4 18 14.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconFullScreen(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M15 6H18V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 10L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 9V6H9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 10L6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 18H6V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 14L6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 15V18H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 14L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17 22H7C4.25 22 2 19.75 2 17V7C2 4.25 4.25 2 7 2H17C19.75 2 22 4.25 22 7V17C22 19.75 19.75 22 17 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconLowdata(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12.0098 7.98047C14.2398 7.98047 16.0398 9.79047 16.0398 12.0105C16.0398 14.2305 14.2298 16.0405 12.0098 16.0405" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.9702 19.6804H6.4102C5.2602 19.6804 4.3302 18.7504 4.3302 17.6004V16.0404C4.3302 15.4904 4.1102 14.9604 3.7202 14.5704L2.6202 13.4704C1.8102 12.6604 1.8102 11.3404 2.6202 10.5304L3.7202 9.43043C4.1102 9.04043 4.3302 8.51043 4.3302 7.96043V6.40043C4.3302 5.25043 5.2602 4.32043 6.4102 4.32043H7.9702C8.5202 4.32043 9.0502 4.10043 9.4402 3.71043L10.5402 2.61043C11.3502 1.80043 12.6702 1.80043 13.4802 2.61043L14.5802 3.71043C14.9702 4.10043 15.5002 4.32043 16.0502 4.32043H17.6102C18.7602 4.32043 19.6902 5.25043 19.6902 6.40043V7.96043C19.6902 8.51043 19.9102 9.04043 20.3002 9.43043L21.4002 10.5304C22.2102 11.3404 22.2102 12.6604 21.4002 13.4704L20.3002 14.5704C19.9102 14.9604 19.6902 15.4904 19.6902 16.0404V17.6004C19.6902 18.7504 18.7602 19.6804 17.6102 19.6804H16.0502C15.5002 19.6804 14.9702 19.9004 14.5802 20.2904L13.4802 21.3904C12.6702 22.2004 11.3502 22.2004 10.5402 21.3904L9.4402 20.2904C9.0502 19.9004 8.5202 19.6804 7.9702 19.6804Z" stroke="currentColor" strokeWidth="1.41" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconMicrophone(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12 19C15.31 19 18 16.31 18 13V8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8V13C6 16.31 8.69 19 12 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 11V13C3 17.97 7.03 22 12 22C16.97 22 21 17.97 21 13V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.10999 7.47969C10.89 6.82969 12.83 6.82969 14.61 7.47969" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.03 10.4799C11.23 10.1499 12.5 10.1499 13.7 10.4799" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Calls — an audio waveform in a circle (the Calls nav entry). */
export function IconCalls(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 9.86035V14.1504" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 8.42969V15.5697" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 7V17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 8.42969V15.5697" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 9.86035V14.1504" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Call — the phone handset (Iconsax "call"). Placing/returning a call. */
export function IconCall(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M21.97 18.33c0 .36-.08.73-.25 1.09-.17.36-.39.7-.68 1.02-.49.54-1.03.93-1.64 1.18-.6.25-1.25.38-1.95.38-1.02 0-2.11-.24-3.26-.73s-2.3-1.15-3.44-1.98a28.75 28.75 0 0 1-3.28-2.8 28.414 28.414 0 0 1-2.79-3.27c-.82-1.14-1.48-2.28-1.96-3.41C2.24 8.94 2 7.85 2 6.81c0-.68.12-1.33.36-1.93.24-.61.62-1.17 1.15-1.67.64-.63 1.34-.94 2.08-.94.28 0 .56.06.81.18.26.12.49.3.67.56l2.32 3.27c.18.25.31.48.4.7.09.21.14.42.14.61 0 .24-.07.48-.21.71-.13.23-.32.47-.56.71l-.76.79c-.11.11-.16.24-.16.4 0 .08.01.15.03.23.03.08.06.14.08.2.18.33.49.76.93 1.28.45.52.93 1.05 1.45 1.58.54.53 1.06 1.02 1.59 1.47.52.44.95.74 1.29.92.05.02.11.05.18.08.08.03.16.04.25.04.17 0 .3-.06.41-.17l.76-.75c.25-.25.49-.44.72-.56.23-.14.46-.21.71-.21.19 0 .39.04.61.13.22.09.45.22.7.39l3.31 2.35c.26.18.44.39.55.64.1.25.16.5.16.78Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"/>
    </Svg>
  );
}

/** Speaker / audio output (audio-call controls). */
export function IconSpeaker(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M3 9.5v5a1 1 0 0 0 1 1h2.6a1 1 0 0 1 .62.22l3.16 2.53A1 1 0 0 0 12 17.47V6.53a1 1 0 0 0-1.62-.78L7.22 8.28a1 1 0 0 1-.62.22H4a1 1 0 0 0-1 1Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M15.5 9.5a4 4 0 0 1 0 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18.2 7a7.5 7.5 0 0 1 0 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </Svg>
  );
}

/** Crown — marks the meeting host in the People panel. */
export function IconCrown(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M4 8.5 7.6 12 12 5.5 16.4 12 20 8.5 18.4 18.5H5.6L4 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round"/>
      <path d="M5.6 18.5h12.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </Svg>
  );
}

/** Add a person to the call. */
export function IconPersonAdd(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 20.5c0-3.04 3.13-5.5 7-5.5 1.06 0 2.07.18 2.97.52" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 15v6M21 18h-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconPeople(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9.16006 10.87C9.06006 10.86 8.94006 10.86 8.83006 10.87C6.45006 10.79 4.56006 8.84 4.56006 6.44C4.56006 3.99 6.54006 2 9.00006 2C11.4501 2 13.4401 3.99 13.4401 6.44C13.4301 8.84 11.5401 10.79 9.16006 10.87Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.4098 4C18.3498 4 19.9098 5.57 19.9098 7.5C19.9098 9.39 18.4098 10.93 16.5398 11C16.4598 10.99 16.3698 10.99 16.2798 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.16021 14.56C1.74021 16.18 1.74021 18.82 4.16021 20.43C6.91021 22.27 11.4202 22.27 14.1702 20.43C16.5902 18.81 16.5902 16.17 14.1702 14.56C11.4302 12.73 6.92021 12.73 4.16021 14.56Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconPin(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M17 22H7C4.25 22 2 19.75 2 17V7C2 4.25 4.25 2 7 2H17C19.75 2 22 4.25 22 7V17C22 19.75 19.75 22 17 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.1302 6.75995C12.6202 6.80995 12.1702 7.07995 11.8802 7.50995L10.7802 9.15995C10.7502 9.20995 10.7002 9.23995 10.6402 9.25995L7.9102 9.93995C7.4902 10.05 7.1502 10.37 7.0302 10.79C6.9102 11.21 7.03014 11.66 7.34014 11.97L12.0102 16.64C12.3202 16.95 12.7701 17.07 13.1901 16.95C13.6101 16.83 13.9402 16.5 14.0402 16.07L14.7201 13.34C14.7301 13.28 14.7701 13.23 14.8201 13.2L16.4701 12.1C16.8901 11.82 17.1701 11.36 17.2201 10.85C17.2701 10.34 17.0902 9.83995 16.7302 9.47995L14.4802 7.22995C14.1402 6.88995 13.6402 6.70995 13.1302 6.75995Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7.49023 16.5101L9.66028 14.3501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconClock(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.71 15.18L12.61 13.33C12.07 13.01 11.63 12.24 11.63 11.61V7.51001" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconStar(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M13.73 3.51L15.49 7.03C15.73 7.52 16.37 7.99 16.91 8.08L20.1 8.61C22.14 8.95 22.62 10.43 21.15 11.89L18.67 14.37C18.25 14.79 18.02 15.6 18.15 16.18L18.86 19.25C19.42 21.68 18.13 22.62 15.98 21.35L12.99 19.58C12.45 19.26 11.56 19.26 11.01 19.58L8.02 21.35C5.88 22.62 4.58 21.67 5.14 19.25L5.85 16.18C5.98 15.6 5.75 14.79 5.33 14.37L2.85 11.89C1.39 10.43 1.86 8.95 3.9 8.61L7.09 8.08C7.62 7.99 8.26 7.52 8.5 7.03L10.26 3.51C11.22 1.6 12.78 1.6 13.73 3.51Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconUserX(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 20.5c0-3.2 2.9-5.5 6.5-5.5 1.3 0 2.5.3 3.5.85" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5 15.5l5 5M21.5 15.5l-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path d="M20 20l-3.2-3.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </Svg>
  );
}

export function IconPlay(props: IconProps) {
  return (
    <Svg {...props}>
      <path fill="currentColor" d="M8.6 4.3a1.6 1.6 0 0 0-2.4 1.4v12.6a1.6 1.6 0 0 0 2.4 1.4l10.3-6.3a1.6 1.6 0 0 0 0-2.8L8.6 4.3Z" />
    </Svg>
  );
}

export function IconStop(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="5.5" y="5.5" width="13" height="13" rx="2.6" fill="currentColor" />
    </Svg>
  );
}

export function IconRecord(props: IconProps) {
  return (
    <Svg {...props}>
      <path fill="currentColor" d="M11.97 2C6.44997 2 1.96997 6.48 1.96997 12C1.96997 17.52 6.44997 22 11.97 22C17.49 22 21.97 17.52 21.97 12C21.97 6.48 17.5 2 11.97 2ZM12 16.23C9.65997 16.23 7.76997 14.34 7.76997 12C7.76997 9.66 9.65997 7.77 12 7.77C14.34 7.77 16.23 9.66 16.23 12C16.23 14.34 14.34 16.23 12 16.23Z" />
    </Svg>
  );
}

/** A padlock on a monitor — E2EE file note (delivered asset). */
export function IconLockedDesktop(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M10.2598 8.86961V7.83961C10.2598 6.87961 11.0398 6.09961 11.9998 6.09961C12.9598 6.09961 13.7398 6.87961 13.7398 7.83961V8.86961" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M13.65 8.68945H10.36C9.44996 8.68945 8.70996 9.42945 8.70996 10.3395V11.8595C8.70996 12.7695 9.44996 13.5095 10.36 13.5095H13.65C14.56 13.5095 15.3 12.7695 15.3 11.8595V10.3395C15.3 9.42945 14.56 8.68945 13.65 8.68945Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M19 18H5C3.34 18 2 16.66 2 15V5C2 3.34 3.34 2 5 2H19C20.66 2 22 3.34 22 5V15C22 16.66 20.66 18 19 18Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 18H10V22H14V18Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 22H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Host controls — horizontal sliders/adjustments (delivered asset). */
export function IconSliders(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M18 7V17C18 17.62 17.98 18.17 17.91 18.66C17.62 21.29 16.38 22 13 22H11C7.62 22 6.38 21.29 6.09 18.66C6.02 18.17 6 17.62 6 17V7C6 6.38 6.02 5.83 6.09 5.34C6.38 2.71 7.62 2 11 2H13C16.38 2 17.62 2.71 17.91 5.34C17.98 5.83 18 6.38 18 7Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 17.0001C6 17.6201 6.02 18.1701 6.09 18.6601C5.95 18.6701 5.82 18.6701 5.67 18.6701H5.33C2.67 18.6701 2 18.0001 2 15.3301V8.67008C2 6.00008 2.67 5.33008 5.33 5.33008H5.67C5.82 5.33008 5.95 5.33008 6.09 5.34008C6.02 5.83008 6 6.38008 6 7.00008V17.0001Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 8.67008V15.3301C22 18.0001 21.33 18.6701 18.67 18.6701H18.33C18.18 18.6701 18.05 18.6701 17.91 18.6601C17.98 18.1701 18 17.6201 18 17.0001V7.00008C18 6.38008 17.98 5.83008 17.91 5.34008C18.05 5.33008 18.18 5.33008 18.33 5.33008H18.67C21.33 5.33008 22 6.00008 22 8.67008Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Document / files (delivered asset) — rounded square with two lines. */
export function IconDocument(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.75 9H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15.75 15H8.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Meeting Tools — a brush/tool inside a rounded square (delivered asset). */
export function IconTools(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12.9 8.54012C13.45 8.61012 13.95 8.85012 14.37 9.27012C14.86 9.76012 15.11 10.3201 15.18 10.9001C15.32 11.9901 14.82 13.1101 14.2 13.7701C13.1 14.9401 10.64 15.6201 8.46002 15.0501C9.68002 13.1001 8.63999 11.3501 9.92999 9.74012C10.64 8.83012 11.82 8.38012 12.9 8.54012Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M21.65 5.18023C20.61 6.39023 19.52 7.57023 18.39 8.69023C17.85 9.23023 17.31 9.77023 16.75 10.2802C16.3 10.6902 15.75 10.8902 15.2 10.8902C15.13 10.3202 14.88 9.76024 14.39 9.27024C13.97 8.85024 13.47 8.61023 12.92 8.54023C12.93 8.01023 13.14 7.48023 13.53 7.06023C15.1 5.36023 16.77 3.75023 18.51 2.24023C19.95 2.69023 21.1 3.79023 21.65 5.18023Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M17 22H7C4.25 22 2 19.75 2 17V7C2 4.25 4.25 2 7 2H17C19.75 2 22 4.25 22 7V17C22 19.75 19.75 22 17 22Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Polls — three vertical bars (a bar chart). */
export function IconPoll(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="6" y1="20" x2="6" y2="11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="12" y1="20" x2="12" y2="4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="18" y1="20" x2="18" y2="14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </Svg>
  );
}

/** Notes — a page with lines (Meeting Tools shared notes). */
export function IconNote(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 3h9l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M14 3v6h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.5 13h7M8.5 16.5h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </Svg>
  );
}

/** Timer — a clock with a leader line (delivered asset). */
export function IconTimer(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M18.6702 16.4399H16.4502" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20.8902 19.78H16.4502" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.56006 12.4299H12.4401V6.43994" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconSpeakerView(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.6 18.5H16.4C17.9 18.5 18.5 17.9 18.5 16.4V14.6C18.5 13.1 17.9 12.5 16.4 12.5H12.6C11.1 12.5 10.5 13.1 10.5 14.6V16.4C10.5 17.9 11.1 18.5 12.6 18.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconStats(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M4.02 5.97C2.75 7.65 2 9.74 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/* ── Design-file inline glyphs (feather style, stroke-width 2) ── */

const F = { stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export function IconPip(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="4.5" width="18" height="14" rx="2" {...F} />
      <rect x="11.5" y="10.5" width="7.5" height="6" rx="1.2" fill="currentColor" {...F} />
    </Svg>
  );
}

export function IconMinimize(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 14h12" {...F} />
    </Svg>
  );
}

export function IconMicOff(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="1" y1="1" x2="23" y2="23" {...F} />
      <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" {...F} />
      <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" {...F} />
      <line x1="12" y1="19" x2="12" y2="23" {...F} />
    </Svg>
  );
}

export function IconCameraOff(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="1" y1="1" x2="23" y2="23" {...F} />
      <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10" {...F} />
    </Svg>
  );
}

export function IconShareScreen(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="2" y="3" width="20" height="14" rx="2" {...F} />
      <line x1="8" y1="21" x2="16" y2="21" {...F} />
      <line x1="12" y1="17" x2="12" y2="21" {...F} />
    </Svg>
  );
}

const LEAVE_ROTATE = { transform: 'rotate(135deg)' } as const;

export function IconLeave(props: IconProps) {
  return (
    <Svg {...props} style={LEAVE_ROTATE}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" {...F} />
    </Svg>
  );
}

export function IconSend(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="22" y1="2" x2="11" y2="13" {...F} />
      <polygon points="22 2 15 22 11 13 2 9 22 2" {...F} />
    </Svg>
  );
}

export function IconDownload(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" {...F} />
      <polyline points="7 10 12 15 17 10" {...F} />
      <line x1="12" y1="15" x2="12" y2="3" {...F} />
    </Svg>
  );
}

export function IconUpload(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" {...F} />
      <polyline points="17 8 12 3 7 8" {...F} />
      <line x1="12" y1="3" x2="12" y2="15" {...F} />
    </Svg>
  );
}

export function IconLock(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="11" width="18" height="11" rx="2" {...F} />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" {...F} />
    </Svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M20 6L9 17l-5-5" {...F} strokeWidth={2.4} />
    </Svg>
  );
}

export function IconCopy(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="9" y="9" width="11" height="11" rx="2.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 15V5.5A1.5 1.5 0 0 1 6.5 4H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </Svg>
  );
}

export function IconChevronDown(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 9l6 6 6-6" {...F} strokeWidth={2.4} />
    </Svg>
  );
}

export function IconChevronLeft(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M15 18l-6-6 6-6" {...F} strokeWidth={2.4} />
    </Svg>
  );
}

export function IconChevronRight(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 18l6-6-6-6" {...F} strokeWidth={2.4} />
    </Svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="18" y1="6" x2="6" y2="18" {...F} />
      <line x1="6" y1="6" x2="18" y2="18" {...F} />
    </Svg>
  );
}

export function IconImage(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="8.5" cy="8.5" r="1.75" stroke="currentColor" strokeWidth="1.5" />
      <path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

export function IconPlus(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="12" y1="5" x2="12" y2="19" {...F} />
      <line x1="5" y1="12" x2="19" y2="12" {...F} />
    </Svg>
  );
}

export function IconTrash(props: IconProps) {
  return (
    <Svg {...props}>
      <line x1="3" y1="6" x2="21" y2="6" {...F} />
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" {...F} />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" {...F} />
    </Svg>
  );
}

export function IconCalendar(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" {...F} />
      <line x1="16" y1="2" x2="16" y2="6" {...F} />
      <line x1="8" y1="2" x2="8" y2="6" {...F} />
      <line x1="3" y1="10" x2="21" y2="10" {...F} />
    </Svg>
  );
}
export function IconDice(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M12.3498 8.65039H5.0498C3.39295 8.65039 2.0498 9.99354 2.0498 11.6504V18.9504C2.0498 20.6072 3.39295 21.9504 5.0498 21.9504H12.3498C14.0067 21.9504 15.3498 20.6072 15.3498 18.9504V11.6504C15.3498 9.99354 14.0067 8.65039 12.3498 8.65039Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.0002 5V12.3C22.0002 13.96 20.6602 15.3 19.0002 15.3H15.3502V11.65C15.3502 9.99 14.0102 8.65 12.3502 8.65H8.7002V5C8.7002 3.34 10.0402 2 11.7002 2H19.0002C20.6602 2 22.0002 3.34 22.0002 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.3898 5.32996C12.3898 5.47996 12.2998 5.60996 12.1598 5.66996C12.0198 5.72996 11.8598 5.69996 11.7598 5.58996C11.6498 5.47996 11.6198 5.32996 11.6798 5.18996C11.7398 5.04996 11.8698 4.95996 12.0198 4.95996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.0195 4.95996C12.2195 4.95996 12.3895 5.12996 12.3895 5.32996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.0402 5.32996C19.0402 5.47996 18.9502 5.60996 18.8102 5.66996C18.6702 5.72996 18.5102 5.69996 18.4102 5.58996C18.3002 5.47996 18.2702 5.32996 18.3302 5.18996C18.3902 5.04996 18.5202 4.95996 18.6702 4.95996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6699 4.95996C18.8699 4.95996 19.0399 5.12996 19.0399 5.32996" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.0398 11.9804C19.0398 12.1804 18.8698 12.3504 18.6698 12.3504C18.4698 12.3504 18.2998 12.1804 18.2998 11.9804C18.2998 11.7804 18.4698 11.6104 18.6698 11.6104" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6699 11.6104C18.8699 11.6104 19.0399 11.7804 19.0399 11.9804" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.3904 11.9804C12.3904 12.1804 12.2204 12.3504 12.0204 12.3504C11.8204 12.3504 11.6504 12.1804 11.6504 11.9804C11.6504 11.7804 11.8204 11.6104 12.0204 11.6104" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.0195 11.6104C12.2195 11.6104 12.3895 11.7804 12.3895 11.9804" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.74 11.9804C5.74 12.1804 5.57 12.3504 5.37 12.3504C5.17 12.3504 5 12.1804 5 11.9804C5 11.7804 5.17 11.6104 5.37 11.6104" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.37012 11.6104C5.57012 11.6104 5.74012 11.7804 5.74012 11.9804" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.07008 15.2997C9.07008 15.4997 8.90008 15.6697 8.70008 15.6697C8.50008 15.6697 8.33008 15.4997 8.33008 15.2997C8.33008 15.0997 8.50008 14.9297 8.70008 14.9297" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.7002 14.9297C8.8002 14.9297 8.8902 14.9697 8.9602 15.0397C9.0302 15.1097 9.0702 15.1997 9.0702 15.2997" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.3904 18.6298C12.3904 18.8298 12.2204 18.9998 12.0204 18.9998C11.8204 18.9998 11.6504 18.8298 11.6504 18.6298C11.6504 18.4298 11.8204 18.2598 12.0204 18.2598" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.0195 18.2598C12.2195 18.2598 12.3895 18.4298 12.3895 18.6298" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.74 18.6298C5.74 18.8298 5.57 18.9998 5.37 18.9998C5.17 18.9998 5 18.8298 5 18.6298C5 18.4298 5.17 18.2598 5.37 18.2598" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.37012 18.2598C5.57012 18.2598 5.74012 18.4298 5.74012 18.6298" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Instant meeting — a bolt with motion lines (New meeting menu). */
export function IconInstant(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9.31993 13.2805H12.4099V20.4805C12.4099 21.5405 13.7299 22.0405 14.4299 21.2405L21.9999 12.6405C22.6599 11.8905 22.1299 10.7205 21.1299 10.7205H18.0399V3.52046C18.0399 2.46046 16.7199 1.96046 16.0199 2.76046L8.44994 11.3605C7.79994 12.1105 8.32993 13.2805 9.31993 13.2805Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.5 4H1.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.5 20H1.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.5 12H1.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Schedule for later — a calendar with a clock badge (New meeting menu). */
export function IconSchedule(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M8 2V5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 2V5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.5 9.08984H20.5" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 23C20.2091 23 22 21.2091 22 19C22 16.7909 20.2091 15 18 15C15.7909 15 14 16.7909 14 19C14 21.2091 15.7909 23 18 23Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19.49 19.0508H16.51" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18 17.5898V20.5798" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 8.5V16.36C20.27 15.53 19.2 15 18 15C15.79 15 14 16.79 14 19C14 19.75 14.21 20.46 14.58 21.06C14.79 21.42 15.06 21.74 15.37 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.9955 13.6992H12.0045" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.29431 13.6992H8.30329" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.29431 16.6992H8.30329" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>
  );
}

/** Zero-knowledge meeting — a fingerprint. FILLED, not stroked: every path
 * needs fill="currentColor" because Svg sets fill="none" for the stroke icons
 * that make up the rest of the set. */
export function IconZeroKnowledge(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M20.3598 20.8998C20.2698 20.8998 20.1698 20.8799 20.0798 20.8499C19.6998 20.6899 19.5098 20.2598 19.6598 19.8698C20.0498 18.9098 20.2398 17.8898 20.2398 16.8398V12.3398C20.2398 11.9298 20.5798 11.5898 20.9898 11.5898C21.3998 11.5898 21.7398 11.9298 21.7398 12.3398V16.8398C21.7398 18.0798 21.5098 19.2898 21.0498 20.4298C20.9398 20.7198 20.6598 20.8998 20.3598 20.8998Z" fill="currentColor"/>
      <path d="M20.3501 9.73039C20.0501 9.73039 19.7701 9.55039 19.6501 9.26039C18.3901 6.15039 15.4101 4.15039 12.0601 4.15039C10.3801 4.15039 8.76012 4.66039 7.38012 5.62039C7.04012 5.86039 6.57011 5.77039 6.34011 5.43039C6.10011 5.09039 6.19011 4.6204 6.53011 4.3904C8.16012 3.2504 10.0701 2.65039 12.0601 2.65039C16.0301 2.65039 19.5501 5.03039 21.0401 8.70039C21.2001 9.08039 21.0101 9.52039 20.6301 9.68039C20.5401 9.71039 20.4401 9.73039 20.3501 9.73039Z" fill="currentColor"/>
      <path d="M3.14014 13.0804C2.73014 13.0804 2.39014 12.7404 2.39014 12.3304C2.39014 10.3404 2.99013 8.42038 4.13013 6.79038C4.37013 6.45038 4.83014 6.37039 5.17014 6.60039C5.51014 6.84039 5.59011 7.31038 5.36011 7.64038C4.40011 9.02038 3.89014 10.6304 3.89014 12.3204C3.89014 12.7404 3.55014 13.0804 3.14014 13.0804Z" fill="currentColor"/>
      <path d="M10.8602 21.3501C10.7202 21.3501 10.5802 21.3101 10.4502 21.2301C10.1002 21.0001 10.0102 20.5401 10.2402 20.1901C11.1102 18.8601 11.5802 17.3101 11.5802 15.7201V12.3301C11.5802 11.9201 11.9202 11.5801 12.3302 11.5801C12.7402 11.5801 13.0802 11.9201 13.0802 12.3301V15.7201C13.0802 17.6101 12.5302 19.4401 11.5002 21.0201C11.3402 21.2301 11.1002 21.3501 10.8602 21.3501Z" fill="currentColor"/>
      <path d="M15.4202 20.7801C15.3002 20.7801 15.1702 20.7501 15.0602 20.6901C14.7002 20.4901 14.5702 20.0301 14.7702 19.6701C15.2802 18.7501 15.6102 17.7501 15.7302 16.7101C15.7502 16.5401 15.7702 16.3701 15.7802 16.2001C15.8002 15.7901 16.1602 15.4701 16.5702 15.4901C16.9802 15.5101 17.3002 15.8701 17.2802 16.2801C17.2702 16.4801 17.2502 16.6901 17.2302 16.8901C17.0802 18.1301 16.7002 19.3101 16.0902 20.4001C15.9402 20.6501 15.6802 20.7801 15.4202 20.7801Z" fill="currentColor"/>
      <path d="M16.5298 13.1001C16.1198 13.1001 15.7798 12.7601 15.7798 12.3501C15.7798 10.2901 14.0998 8.62012 12.0498 8.62012C10.9398 8.62012 9.90981 9.11013 9.19981 9.96013C8.92981 10.2801 8.45981 10.3201 8.13981 10.0601C7.81981 9.80012 7.7798 9.32012 8.0398 9.00012C9.0298 7.80012 10.4898 7.12012 12.0498 7.12012C14.9398 7.12012 17.2798 9.47013 17.2798 12.3501C17.2798 12.7601 16.9498 13.1001 16.5298 13.1001Z" fill="currentColor"/>
      <path d="M7.01004 18.6601C6.88004 18.6601 6.75004 18.6301 6.64004 18.5601C6.28004 18.3501 6.16001 17.8901 6.36001 17.5401C6.68001 16.9801 6.85003 16.3501 6.85003 15.7001V12.3301C6.85003 11.9201 7.19003 11.5801 7.60003 11.5801C8.01003 11.5801 8.35003 11.9201 8.35003 12.3301V15.7001C8.35003 16.6101 8.11003 17.5001 7.66003 18.2901C7.52003 18.5301 7.27004 18.6601 7.01004 18.6601Z" fill="currentColor"/>
      <path d="M2.99975 17.5499C2.93975 17.5499 2.87975 17.5398 2.80975 17.5298C2.40975 17.4298 2.16974 17.0198 2.26974 16.6198C2.34974 16.3198 2.37975 16.0199 2.37975 15.7099V12.3398C2.37975 11.9298 2.71975 11.5898 3.12975 11.5898C3.53975 11.5898 3.87975 11.9298 3.87975 12.3398V15.7099C3.87975 16.1399 3.82975 16.5799 3.71975 16.9899C3.63975 17.3199 3.33975 17.5499 2.99975 17.5499Z" fill="currentColor"/>
    </Svg>
  );
}

export function IconSmile(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="10" {...F} />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" {...F} />
      <line x1="9" y1="9" x2="9.01" y2="9" {...F} />
      <line x1="15" y1="9" x2="15.01" y2="9" {...F} />
    </Svg>
  );
}

export function IconDots(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="5" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="12" cy="19" r="1.8" fill="currentColor" stroke="none" />
    </Svg>
  );
}

export function IconFile(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" {...F} />
      <path d="M13 2v7h7" {...F} />
    </Svg>
  );
}

export function IconGear(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="3" {...F} strokeWidth={1.8} />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" {...F} strokeWidth={1.8} />
    </Svg>
  );
}

export function IconHand(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M18 11V6a2 2 0 0 0-4 0v5M14 10V4a2 2 0 0 0-4 0v6M10 10.5V6a2 2 0 0 0-4 0v8" {...F} />
      <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34L4.7 18.35c-.86-1.06-.86-2.58.12-3.47a2 2 0 0 1 2.72.05L9 16.4" {...F} />
    </Svg>
  );
}
